import { createAction, props } from "@ngrx/store";
import { Task } from "../../models/task.model";

export const LOAD_TASKS = '[Task] Load tasks';
export const LOAD_TASKS_SUCCESS = '[Task] Load tasks success';
export const LOAD_TASKS_FAIL = '[Task] Load tasks fail';
export const ADD_TASK = '[Task] Add task';
export const ADD_TASK_SUCCESS = '[Task] Add task success';
export const ADD_TASK_FAIL = '[Task] Add task fail';
export const DELETE_TASK = '[Task] Delete task';
export const DELETE_TASK_SUCCESS = '[Task] Delete task success';
export const DELETE_TASK_FAIL = '[Task] Delete task fail';
export const UPDATE_TASK = '[Task] Update task';
export const UPDATE_TASK_SUCCESS = '[Task] Update task success';
export const UPDATE_TASK_FAIL = '[Task] Update task fail';

export const LoadTasksAction = createAction(
    LOAD_TASKS,
    props<{ month: number; year: number; userId: string; }>()
);

export const LoadTasksSuccessAction = createAction(
    LOAD_TASKS_SUCCESS,
    props<{ data: Task[] }>()
);

export const LoadTasksFailAction = createAction(
    LOAD_TASKS_FAIL,
    props<{ error: Error }>()
);

export const AddTaskAction = createAction(
    ADD_TASK,
    props<{ data: Task }>()
);

export const AddTaskSuccessAction = createAction(
    ADD_TASK_SUCCESS,
    props<{ data: Task[] }>()
);

export const AddTaskFailAction = createAction(
    ADD_TASK_FAIL,
    props<{ error: Error }>()
);

export const DeleteTaskAction = createAction(
    DELETE_TASK,
    props<{ data: Task }>()
);

export const DeleteTaskSuccessAction = createAction(
    DELETE_TASK_SUCCESS,
    props<{ data: Task[] }>()
);

export const DeleteTaskFailAction = createAction(
    DELETE_TASK_FAIL,
    props<{ error: Error }>()
);

export const UpdateTaskAction = createAction(
    UPDATE_TASK,
    props<{ data: Task }>()
);

export const UpdateTaskSuccessAction = createAction(
    UPDATE_TASK_SUCCESS,
    props<{ data: Task[] }>()
);

export const UpdateTaskFailAction = createAction(
    UPDATE_TASK_FAIL,
    props<{ error: Error }>()
);
